import type * as SchemaTypes from '../types';

import type { TranslatedStringDataFragment } from './TranslatedStringData';
import type { DealerContactFragmentFragment } from './DealerContactFragment';
import type { DealerSocialMediaFragmentFragment } from './DealerSocialMediaFragment';
import type { UploadFileWithPreviewFormDataFragment } from './UploadFileWithPreviewFormData';
import type { DealerIntegrationDetailsFragmentFragment } from './DealerIntegrationDetailsFragment';
import { gql } from '@apollo/client';
import { TranslatedStringDataFragmentDoc } from './TranslatedStringData';
import { DealerContactFragmentFragmentDoc } from './DealerContactFragment';
import { DealerSocialMediaFragmentFragmentDoc } from './DealerSocialMediaFragment';
import { UploadFileWithPreviewFormDataFragmentDoc } from './UploadFileWithPreviewFormData';
import { DealerIntegrationDetailsFragmentFragmentDoc } from './DealerIntegrationDetailsFragment';
export type DealerListDataFragment = (
  { __typename: 'Dealer' }
  & Pick<SchemaTypes.Dealer, 'id' | 'displayName' | 'isActive' | 'userIds' | 'coe' | 'ppsr' | 'estFee'>
  & { legalName: (
    { __typename: 'TranslatedString' }
    & TranslatedStringDataFragment
  ), contact: (
    { __typename: 'DealerContact' }
    & DealerContactFragmentFragment
  ), integrationDetails: (
    { __typename: 'DealerIntegrationDetails' }
    & DealerIntegrationDetailsFragmentFragment
  ), company: (
    { __typename: 'Company' }
    & Pick<SchemaTypes.Company, 'id' | 'displayName'>
  ) }
);

export const DealerListDataFragmentDoc = /*#__PURE__*/ gql`
    fragment DealerListData on Dealer {
  id
  displayName
  isActive
  userIds
  coe
  ppsr
  estFee
  legalName {
    ...TranslatedStringData
  }
  contact {
    ...DealerContactFragment
  }
  integrationDetails {
    ...DealerIntegrationDetailsFragment
  }
  company {
    id
    displayName
  }
}
    `;